<div id="fade"></div>
<div id="modal">
    <img style="margin-bottom:10px;" id="loader" src="/Cache/images/icon_load.gif" /><br />
    <label style="color:black;"><strong>{{smDataService.modalMsg}}</strong></label>
    <button class="btn btn-danger" type="button" (click)="turnoffOffline()" *ngIf="smDataService.initLoading" style="white-space: initial; margin-bottom: 10px;">Turn Off Offline Setting</button>
</div>

<nav id="NavBar" class="navbar nav navbar-expand-custom navbar-inverse fixed-top" role="navigation" style="padding-left:0;">
    <div class="sidenav" id="globalSideNav">
        <a href="javascript:void(0)" class="closebtn" (click)="closeGlobalNav(null)">&times;</a>
        <div id="navOptions" style="margin-left:25px;">
            <ul style="padding-left:0px;">
                <li style="font-size: 20px;">
                    Navigation
                </li>
                <li *ngIf="smDataService.currentOnline">
                    <a id="homeButton" class="dropdown-item" style="font-size: 15px;cursor:pointer;" href="/home/index" (click)="routeToHome()">
                        <span class="oi oi-home"></span> Home <div style="margin-left:5px;"></div>
                    </a>
                </li>
                <li *ngIf="showWODash">
                    <a class="dropdown-item" [routerLink]="'/sm/manage'" (click)="closeGlobalNav('manage')" style="font-size: 15px;cursor:pointer">
                        <span class="oi oi-clipboard"></span> Work Order Dashboard <div style="margin-left:5px;"></div>
                    </a>
                </li>
                <li *ngIf="smDataService.currentOnline && showSMManagerDash">
                    <a class="dropdown-item" [routerLink]="'/sm/workorderdashboard'" (click)="closeGlobalNav('service')" style="font-size: 15px;">
                        <span class="oi oi-spreadsheet"></span> Service Manager Dashboard <div style="margin-left:5px;"></div>
                    </a>
                </li>
                <li *ngIf="smDataService.currentOnline">
                    <a id="timecardButton" class="dropdown-item" [routerLink]="" style="font-size: 15px;cursor:pointer;" (click)="saveURL()">
                        <span style="" class="oi oi-clock"></span> Timecard <div style="margin-left:5px;"></div>
                    </a>
                </li>
                <li *ngIf="smDataService.currentOnline">
                    <a class="dropdown-item" [routerLink]="" (click)="logout()" style="font-size: 15px;cursor:pointer;">
                        <span style="transform: rotate(180deg)" class="oi oi-account-logout"></span> Logout
                    </a>
                </li>
            </ul>
            <hr />
            <ul style="padding-left:0px;" *ngIf="enablePWA">
                <li style="font-size: 20px;">Settings</li>
                <li>
                    <div style="display: -webkit-inline-box;padding: 8px 8px 8px 32px;color: #818181;transition: 0.3s;text-decoration: none;">
                        <span style="margin-top: 5px;margin-right: 5px;display: block;">Enable Offline Access</span>
                        <div class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="EnableOfflineFS" (click)="userSettingUpdate(true)" [(ngModel)]="formData.enableOfflineAccess" [disabled]="!smDataService.currentOnline">
                            <label class="custom-control-label" for="EnableOfflineFS"></label>
                        </div>
                    </div>
                </li>
                <li><span>Select "Add to Home" to install this application.</span><br /><span>This may slow the initial load of your work order trips.</span></li>
                <li *ngIf="formData.enableOfflineAccess" style="padding: 8px 8px 8px 32px;">
                    <button class="btn btn-danger" type="button" (click)="clearDB()">Clear Offline Data</button>
                </li>
            </ul>
        </div>
    </div>

    <div class="container-fluid" style="padding-bottom: 2px;">
        <div class="row">
            <a id="brand" class="navbar-brand" style="display: inline-flex;color:black;margin-left:5px;cursor:pointer;" (click)="closeGlobalNav('manage')" [routerLink]="">
                <img id="logo" style="display: inline;max-width:75px;height:30px;" [src]="logoUrl" alt="" />
                <span style="margin-left: 10px; color: black; margin-top: 5px;">Field Service</span>
            </a>
        </div>
        <div class="row">
            <div class="col-xs-2" style="width:130px;vertical-align:super;text-align: center;" *ngIf="employeeInfo.SMEnableFSClock && smDataService.currentOnline && !notTech">
                <button class="btn btn-success" data-telemetryId="sMNavClockIn" type="button" *ngIf="(!smDataService.clockInStatus?.ClockAction || smDataService.clockEmpty) && !smDataService.isFromSMWODashNow" (click)="clockAction()">Clock In <span class="oi oi-account-login"></span></button>
                <button class="btn btn-danger" type="button" *ngIf="smDataService.clockInStatus?.ClockAction && !smDataService.clockEmpty && !smDataService.isFromSMWODashNow" (click)="clockAction()" style="display:inline-flex">Clock Out <span class="oi oi-account-logout" style="transform: rotate(180deg);margin-left:5px;margin-top:4px;"></span></button>
            </div>
            <div class="col-xs-2" style="width:30px;vertical-align:super;text-align: center;margin-right:5px;"><span class="oi oi-menu" style="font-size: x-large;color:black;cursor:pointer;" (click)="openGlobalNav()"></span></div>
        </div>

        <div class="hidden-sm hidden-xs navbar-collapse collapse">
            <ul class="nav navbar-nav navbar-right">
                <li>
                    <a class="dropdown-item" [routerLink]="" (click)="logout()" style="font-size: 15px;">
                        Logout <div style="margin-left:5px;" class="oi oi-account-logout"></div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="container-fluid" style="display: block;" *ngIf="enablePWA && smDataService.currentOnline && smDataService.haveOfflinePost && !isServiceManager">
        <div class="alert alert-warning" style="margin: 10px; display: block;">
            You have unsynced data <button class="btn btn-outline-success" type="button" (click)="triggerOfflinePost()">Sync Now</button><span *ngIf="smDataService.haveOfflinePostFail" style="color: red; float: right; font-size: x-large;" class="oi oi-warning"></span>
        </div>
    </div>
</nav>
